import React from "react";
import Button from "@mui/material/Button";
import ArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import "../../../styles/button.scss"


const BackButton = ({label='', onClick = () => {}, style= {}}) => {

    return <Button variant="contained" color="primary" onClick={onClick} sx={{ marginRight:2, marginTop:2, width: { xs: '100%', sm: 'auto' } }} >
        <ArrowLeft />
        {label}
    </Button>
}

export default BackButton
